import { Box, CircularProgress, Fade, SxProps, Typography } from "@mui/material";
import { ICandidateNote } from "../../../App/Typings/CandidateProfile";
import { useNotesState } from "./State/NotesState";
import AddNote from "./Subcomponents/AddNote";
import Note from "./Subcomponents/Note";

function sortNotes(notes: ICandidateNote[]): ICandidateNote[] {
  return notes.sort((a, b) => {
    return new Date(b.createDate).getTime() - new Date(a.createDate).getTime();
  });
}
/**
 * @description Creates a card that enables communication between coworkers about Candidate
 * @returns Note card
 */
export function Notes({ sx }: { sx?: SxProps }) {
  const {
    getters: { notes, notesFetched },
  } = useNotesState();
  const hasNotes = notes?.length > 0;
  const sortedNotes = notes ? sortNotes(notes) : [];

  return notesFetched ? (
    <Fade in={notesFetched} timeout={500}>
      <Box sx={sx}>
        {hasNotes ? (
          sortedNotes.map((note) => <Note note={note} key={note.id} />)
        ) : (
          <Box id={`note-nonotesadded`} data-test={`note-nonotesadded`}>
            <Typography id="candidatenotes-none" data-test="candidatenotes-none">
              No notes have been added for this Candidate. Add a note below to start the conversation on this
              candidate!
            </Typography>
          </Box>
        )}
        <AddNote />
      </Box>
    </Fade>
  ) : (
    <Box sx={{ minHeight: 500, display: "flex", alignItems: "center", justifyContent: "center" }}>
      <CircularProgress />
    </Box>
  );
}
